import { ThunkDispatch } from "core-integration/src/store";
import { proposeElement } from "core-integration/src/store/squad/thunks";
import { integerToMoney, isMoneyStat } from "core-integration/src/utils/money";
import { useDispatch } from "react-redux";
import { integerToMoneyWithCurrency } from "../../utils/money";
import AddElement from "../AddElement";
import ElementDialogButton from "../ElementDialogButton";
import ElementInTable from "../ElementInTable";
import {
  addElementButton,
  elementListRowElement,
  elementListRowStyles,
  elementListStat,
  elementListStatus,
} from "./elementListRow.css";
import { ElementListRowProps } from "./types";

const ElementListRow = ({
  currencyDivisor,
  element,
  isProposed,
  team,
  hasAddElement,
  sort,
  handleClose,
}: ElementListRowProps) => {
  const dispatch = useDispatch<ThunkDispatch>();

  const addElement = (elementId: number) => {
    dispatch(proposeElement(elementId));
    if (handleClose) {
      handleClose();
    }
  };

  const rowElementVariant = isProposed ? "proposed" : "default";

  return (
    <tr className={elementListRowStyles}>
      <td className={elementListStatus}>
        <ElementDialogButton elementId={element.id} variant="list" />
      </td>
      <th scope="row" className={elementListRowElement[rowElementVariant]}>
        <ElementInTable
          actionMe={() => addElement(element.id)}
          element={element}
          team={team}
          renderDreamTeam={element.in_dreamteam}
        />
      </th>
      <td className={elementListStat}>
        {integerToMoneyWithCurrency(element.now_cost, currencyDivisor)}
      </td>
      <td className={elementListStat}>
        {isMoneyStat(sort)
          ? integerToMoney(element[sort] as number, currencyDivisor)
          : element[sort]}
      </td>

      {hasAddElement && (
        <td className={addElementButton}>
          <AddElement element={element} />
        </td>
      )}
    </tr>
  );
};

export default ElementListRow;
